// Pre-loaded common US zip code coordinates to speed up map loading
// This includes major cities and common zip codes to reduce API calls

export const preloadedZipCodes = {
  // California
  '93446': { lat: 35.1321, lng: -120.6297, display_name: 'Paso Robles, CA' },
  '95630': { lat: 38.7146, lng: -121.0810, display_name: 'Folsom, CA' },
  
  // Arizona
  '85213': { lat: 33.4170, lng: -111.5497, display_name: 'Mesa, AZ' },
  
  // Texas  
  '78266': { lat: 30.0799, lng: -98.8666, display_name: 'Spring Branch, TX' },
  '78666': { lat: 30.0891, lng: -97.8395, display_name: 'San Marcos, TX' },
  
  // Utah
  '84663': { lat: 39.5631, lng: -111.5854, display_name: 'Springville, UT' },
  '84058': { lat: 40.4818, lng: -111.9124, display_name: 'Orem, UT' },
  
  // Minnesota
  '55372': { lat: 44.9375, lng: -93.4995, display_name: 'Prior Lake, MN' },
  '55760': { lat: 46.7220, lng: -92.5151, display_name: 'Hoyt Lakes, MN' },
  '56308': { lat: 46.1258, lng: -94.9508, display_name: 'Alexandria, MN' },
  
  // Montana
  '59101': { lat: 45.7833, lng: -108.5007, display_name: 'Billings, MT' },
  
  // Ohio
  '45014': { lat: 39.3912, lng: -84.5697, display_name: 'Fairfield, OH' },
  
  // Georgia
  '30506': { lat: 34.5329, lng: -83.9849, display_name: 'Gainesville, GA' },
  
  // Tennessee
  '37922': { lat: 35.9656, lng: -84.0660, display_name: 'Knoxville, TN' },
  '37932': { lat: 35.9062, lng: -84.1541, display_name: 'Knoxville, TN' },
  '37312': { lat: 35.4731, lng: -85.0328, display_name: 'Cleveland, TN' },
  '38401': { lat: 35.6145, lng: -87.0353, display_name: 'Columbia, TN' },
  
  // Wisconsin
  '54904': { lat: 44.0194, lng: -88.5426, display_name: 'Oshkosh, WI' },
  '54810': { lat: 46.4466, lng: -90.1718, display_name: 'Ashland, WI' },
  
  // South Carolina
  '29678': { lat: 34.5034, lng: -82.6501, display_name: 'Seneca, SC' },
  
  // North Carolina
  '27850': { lat: 36.2946, lng: -76.2510, display_name: 'Hertford, NC' },
  
  // Pennsylvania
  '16316': { lat: 41.2356, lng: -80.3906, display_name: 'Conneaut Lake, PA' },
  
  // Oklahoma
  '74074': { lat: 36.4596, lng: -95.9808, display_name: 'Stillwater, OK' },
  
  // Colorado
  '80528': { lat: 40.4528, lng: -105.0774, display_name: 'Fort Collins, CO' },
  
  // Florida
  '34711': { lat: 28.0475, lng: -81.9534, display_name: 'Clermont, FL' },
  '33330': { lat: 26.1901, lng: -80.3659, display_name: 'Sunrise, FL' },
  
  // Michigan
  '49504': { lat: 42.9192, lng: -85.7041, display_name: 'Grand Rapids, MI' },
  
  // Indiana
  '46350': { lat: 41.5475, lng: -87.3650, display_name: 'La Porte, IN' },
  
  // Idaho
  '83642': { lat: 43.5985, lng: -116.5940, display_name: 'Meridian, ID' },
  
  // Washington
  '98520': { lat: 46.5979, lng: -122.9659, display_name: 'Aberdeen, WA' },
  
  // Nevada
  '89511': { lat: 39.5296, lng: -119.8138, display_name: 'Reno, NV' },
  
  // Oregon
  '97301': { lat: 44.9429, lng: -123.0351, display_name: 'Salem, OR' },
  
  // Louisiana
  '70816': { lat: 30.4147, lng: -91.0511, display_name: 'Baton Rouge, LA' },
};

// Function to check if we have pre-loaded coordinates for a zip
export const getPreloadedCoordinates = (zip) => {
  const cleanZip = zip ? zip.toString().replace(/\r|\n|\s/g, '').substring(0, 5) : '';
  return preloadedZipCodes[cleanZip] || null;
};
